import { Vue, Component, Prop, Inject } from 'vue-property-decorator';

@Component({
    name: 'custom-metadata-panel',
})
export default class CustomMetadataPanel extends Vue {

    @Prop()
    public isSubmitted!: boolean;

    @Inject('validator') public $validator: any;

    // ------------------------------------------------------------
    // Properties

    @Prop()
    private filterKey: any;

}
